export enum CardTypes {
	APPROVED = "APPROVED",
	CONFIRMATION_GENERATED = "CONFIRMATION_GENERATED",
	RECEIVE_CONFIRMATION = "RECEIVE_CONFIRMATION",
	REJECTED = "REJECTED",
}
